import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IManager } from 'src/app/core/models/i-manager';
import { ISector } from 'src/app/core/models/i-sector';
import { RELATED_MANAGER_FORM_FIELDS } from './constants/form-fields';
import { RELATED_MANAGER_FORM_PATHS } from './constants/form-paths';
import { ALL_SECTORS_SELECTED, NO_SECTORS_SELECTED } from './constants/sectors';
import { ISelectListItem } from '../../interfaces/i-select-list-item';

@Component({
  selector: 'app-related-manager-item',
  templateUrl: './related-manager-item.component.html',
  styleUrls: ['./related-manager-item.component.scss'],
})
export class RelatedManagerItemComponent {
  RELATED_MANAGER_FORM_FIELDS = RELATED_MANAGER_FORM_FIELDS;
  RELATED_MANAGER_FORM_PATHS = RELATED_MANAGER_FORM_PATHS;
  ALL_SECTORS_SELECTED = ALL_SECTORS_SELECTED;
  NO_SECTORS_SELECTED = NO_SECTORS_SELECTED;

  @Input() managerControl: FormGroup;
  @Input() availableSectors: ISector[];
  @Input() isSurtitleButtonShown: boolean = false;
  @Input() isSmartLinked: boolean = false;

  @Output() handleRemove = new EventEmitter();
  @Output() handleAdd = new EventEmitter();
  @Output() handleAddToBody = new EventEmitter<IManager>();
  @Output() handleInfoClick = new EventEmitter<IManager>();
  @Output() handleSectorChange = new EventEmitter();
  @Output() handlePromote = new EventEmitter<ISelectListItem>();

  isChangingSector: boolean = false;
  isHovered: boolean = false;

  ngOnInit() {
    this.managerControl
      .get(this.RELATED_MANAGER_FORM_PATHS.SELECTED_SECTOR())
      .valueChanges.subscribe((newValue) => {
        this.isChangingSector = false;
        this.handleSectorChange.emit();
      });
  }

  onRemove(item: IManager) {
    this.handleRemove.emit(item);
  }

  onAdd(item: IManager) {
    this.handleAdd.emit(item);
  }

  onAddToBody(item: IManager) {
    this.handleAddToBody.emit(item);
  }

  onInfoClick(item: IManager) {
    this.handleInfoClick.emit(item);
  }

  toggleShowSectorChange() {
    this.isChangingSector = !this.isChangingSector;
  }

  getSectorDescription(): string {
    const selectedSector = this.managerControl.get(
      this.RELATED_MANAGER_FORM_PATHS.SELECTED_SECTOR()
    ).value;
    if (!selectedSector) {
      return 'All sectors selected';
    }

    switch (selectedSector) {
      case NO_SECTORS_SELECTED:
        return 'No sectors selected';
      case ALL_SECTORS_SELECTED:
        return 'All sectors selected';
      default:
        return selectedSector.name;
    }
  }

  compareSelectedSector(option: ISector, selection: ISector): boolean {
    return option.id === selection.id;
  }

  handleManagerRating(rating: string): boolean {
    return rating !== undefined && rating.toLowerCase() !== 'notrated';
  }

  promoteToSurtitle(manager: IManager) {
    const selectListItem: ISelectListItem = {
      displayName: `${manager.firstName} ${manager.lastName}`,
      id: manager.id.toString(),
    };
    this.handlePromote.emit(selectListItem);
  }
}
